import { useState } from "react";
import { kanbanInsert } from "../../utils/kanban2";

import './KanbanOrder.scss';

export default function KanbanOrder() {
  const [items, setItems] = useState(["BBBBBB", "BBBBBC", "BBBBBZ" ]);

  const onInsert = index => {
    setItems(kanbanInsert(items, index));
  }

  return (
    <section className="__dev-kanban-order">
      <h3>KANBAN ORDER</h3>
      
      <div className="sort-container">
        { items.toReversed().map((order, index) => (
          <Item key={order} order={order} index={items.length - index - 1} last={index === items.length - 1} onInsert={onInsert} />
        ))}
      </div>
    </section>
  )
}

const Item = ({ index, order, last, onInsert }) => (
  <div className="item">
    <button className="add" onClick={() => onInsert(index + 1)}>+</button>
    <code style={{ color: 'black'}}>{ order }</code>
    { last && <button className="add add-end" onClick={() => onInsert(index)}>+</button> }
  </div>
);
